import React from "react";
import { Button, Typography, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import ContainerWrapper from "./ContainerWrapper";

const useStyles = makeStyles((theme) => ({
  pageNotFoundRoot: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column !important",
    textAlign: "center",
    "&>h3": {
      marginBottom: "15px",
    },
    "&>button": {
      marginTop: "15px",
    },
  },
}));

export default function PageNotFound() {
  const classes = useStyles();

  const navigate = useNavigate();

  return (
    // <ContainerWrapper>
    <Grid className={classes.pageNotFoundRoot}>
      <Typography variant="h1" semiBold>
        404
      </Typography>
      <Typography variant="h5" semiBold>
        OOPS! PAGE NOT FOUND
      </Typography>
      <Button variant="contained" bigBold onClick={() => navigate("/home")}>
        Go Back
      </Button>
    </Grid>
    // </ContainerWrapper>
  );
}
